import { useEffect, useRef } from 'react';
import { usePopups } from '@hooks/popups/usePopups';
import { useUserData } from '@hooks/useUserData';
import { RESCUE_POPUP_SOURCE } from '@components/popups/RescuePopup/RescuePopup.constants';

/**
 * When the rescue offer follows the paywall. Mounted by the `RescuePopup`
 * island, which the host includes on funnel pages only — the SPA never mounts
 * it, so closing the paywall on a tool page offers nothing.
 *
 * The paywall closes (any close) and the user has no running subscription
 * (never bought, cancelled, expired) — `isUserSubscribed` is false → the offer.
 * A `?modal=rescue` link is opened by `usePopupAutoOpen`, with the other links.
 */
export const useRescuePopupTriggers = () => {
  const { popups, openPopup } = usePopups();
  const { isUserSubscribed } = useUserData();

  const isPaywallOpen = Boolean(popups.SubscriptionPopup?.isOpen);
  const wasPaywallOpenRef = useRef(isPaywallOpen);

  useEffect(() => {
    if (wasPaywallOpenRef.current && !isPaywallOpen && !isUserSubscribed) {
      openPopup('RescuePopup', { source: RESCUE_POPUP_SOURCE.PAYWALL_CLOSE });
    }

    wasPaywallOpenRef.current = isPaywallOpen;
  }, [isPaywallOpen, isUserSubscribed, openPopup]);
};
